import classNames from "classnames";
import { Icon } from "../icon/icon";

export type SelectInputProps = {
  title: string;
  subTitle?: string;
  iconSvg?: string;
  selected: boolean;
  disabled?: boolean;
  iconWidth?: number;
  iconHeight?: number;
  onSelect: () => void;
  className?: string;
};

export const SelectInput = ({
  title,
  subTitle,
  iconSvg,
  selected,
  disabled = false,
  onSelect,
  iconWidth = 24,
  iconHeight = 24,
  className = "",
}: SelectInputProps) => {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onSelect}
      className={classNames(
        "flex w-full items-center justify-between rounded-2xl bg-grey-50 p-4 transition-colors",
        "focus:outline-none disabled:cursor-not-allowed disabled:opacity-60",
        className,
      )}
    >
      <div className="flex items-center gap-5">
        {iconSvg && (
          <Icon
            svg={iconSvg}
            width={iconWidth}
            height={iconHeight}
            className="text-grey-500"
          />
        )}

        <div className="flex flex-col items-start text-left">
          <p className="font-bold text-primary">{title}</p>
          {subTitle && <p className="text-sm text-grey-600">{subTitle}</p>}
        </div>
      </div>

      <Icon
        svg={selected ? "checkbox-two-active" : "checkbox-two-inactive"}
        width={21}
        height={20}
        className="w-fit"
      />
    </button>
  );
};
